import { fetchBoards } from '@modules/board/hooks/useBoardsQuery';
import { useEffect } from 'react';
import { useWorkspaceFeaturesSettings } from 'src/hooks/useWorkspace';
import { startSessionFromMobile } from 'src/state';
import useUIState from 'src/state/ui/persistUiState';
import { sendCollaborateBridgeMessage } from './bridge';
import { useCollaborateBridgeListener } from './hooks';
import { MessagesTypes } from './types';

export const CollaborateBridgeInitializer = () => {
  const { setPreferenceState } = useUIState();
  const { smartTodos } = useWorkspaceFeaturesSettings();

  useEffect(() => {
    sendCollaborateBridgeMessage({ type: MessagesTypes.READY });
  }, []);

  useCollaborateBridgeListener(MessagesTypes.AUTH_DATA, async (data) => {
    const { accessTokens, user, accountToken, lastLocation } = data.payload;

    let lastPath = 'todo';

    if (!smartTodos) {
      const boards = await fetchBoards();
      if (boards.length > 0) lastPath = `boards/${boards[0]._id}`;
      else lastPath = 'boards';
    }

    const slug = startSessionFromMobile({
      accessTokens,
      user,
      accountToken,
      lastLocation,
      lastPath,
    });

    user.myUsers.forEach((userItem: any) => {
      setPreferenceState(userItem._id, {
        themeMode: 'dark',
        themeContrast: 'default',
      });
    });

    window.location.replace(`/${slug}/signed-in/`);
  });

  return null;
};
